import React from 'react';
import {useTranslation} from 'react-i18next';
import {BoxType} from '@taopix/taopix-core';
import {AddPicturesIcon} from '@taopix/taopix-design-system';
import AddItemButton from './AddItemButton';

const AddPictureBoxButton = ({enabled, pageNumber, buttonProps}) => {
  const {t} = useTranslation();
  return (
    <AddItemButton
      boxType={BoxType.Image}
      enabled={enabled}
      pageNumber={pageNumber}
      buttonProps={buttonProps}
      icon={<AddPicturesIcon />}
      label={t('str_LabelAddPictureBox', {
        ns: 'stubar',
      })}
    />
  );
};

export default AddPictureBoxButton;
